import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5589086f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EoPVerificationReport" }
const _hoisted_2 = {
  key: 0,
  class: "content-container loader-style"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading loader-style" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-container"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "top-container" }
const _hoisted_8 = { class: "eop-v-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Name:", -1))
const _hoisted_10 = { style: {"font-weight":"bold"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Period:", -1))
const _hoisted_12 = { style: {"font-weight":"bold"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Status:", -1))
const _hoisted_14 = {
  key: 0,
  class: "failure"
}
const _hoisted_15 = {
  key: 1,
  class: "highlight-green-bold"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Journaling Status:", -1))
const _hoisted_18 = {
  key: 0,
  class: "failure"
}
const _hoisted_19 = {
  key: 1,
  class: "highlight-green-bold"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Processed:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Total Amount Expected:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Total Amount Received:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Total Amount Deviation:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Number of Errors:", -1))
const _hoisted_27 = { class: "new-report-button-div" }
const _hoisted_28 = ["disabled", "title"]
const _hoisted_29 = ["disabled", "title"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "table-header-box" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Detailed Report", -1))
const _hoisted_33 = { class: "table-container" }

import { ref, onMounted, computed } from "vue";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import { useRoute, useRouter } from "vue-router";
import log from "loglevel";
import { authService } from "@/auth/authSingleton";
import EopVerificationReportHistoryPopUp from "./EopVerificationReportHistoryPopUp.vue";
import { DisplayableKeys } from "@/services/SorterService";
import TickCrossBooleanDisplay from "@/components/TickCrossBooleanDisplay.vue";
import Table, {ITableExpose} from "@/components/TablePersistentChecking.vue";
import MultiplePeriodEoPVerificationReportPopUp from "@/components/MultiplePeriodEoPVerificationReportPopUp.vue"
import { eoPCreateNewReport, eoPVerificationReport } from "@/services/network";
import IEoPCreateNewReport from "@/Interfaces/EoPVerifications/IEoPCreateNewReport";
import EoPVerificationReportOperation from "@/Interfaces/EoPVerifications/EoPVerificationReportOperation"
import EoPReportSpecifications from "@/Interfaces/EoPVerifications/EoPReportSpecifications";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import IEoPVerificationRequestParams from "@/Interfaces/EoPVerifications/IEoPVerificationRequestParams";
import ExportCsv from "@/components/ExportCsv.vue";
import DatePeriod from "@/types/DatePeriod";
import { IEoPItem } from "@/Interfaces/EoPVerifications/IEoPVerifications";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewEoPVerificationReport',
  props: {
    displayedEoPVerificationsList: {}
  },
  setup(__props: any) {

const router = useRouter();
const route = useRoute();

onMounted(async () => {
    await router.isReady();
    log.trace("onMounted() EoPVerificationReport");
    document.title = `EoP Verification (${journalType.value}) - UV`;
    userName.value = authService.getEmailAddress()
    await GetEoPVerificationReport(journalType.value,market,period.value).then(() => {});
});

const props = __props;
const userName = ref("");

const journalType = computed(()=> { return route.path.split("/").pop() as string});
const market = route.query.market?.toString() as string;
const period = computed(()=> { return route.query.period?.toString() as string});
const filteredTableData = computed(() => {
      return table.value?.GetFiltered() ?? [];
});
const popUpOpen = ref(false)
const showMultiplePeriodReportPopUp = ref(false)

// Get EoP Verification Report Data from API
async function GetEoPVerificationReport(journalType: string, market: string, period: string) {
    if(isLoadingReport.value) return
    try {
        isLoadingReport.value = true
        const eoPRequest: IEoPVerificationRequestParams = {
            market: market, 
            period: period, 
            eoPType: journalType,
            mostRecentOnly: true
        }
        const data = (await eoPVerificationReport.get(eoPRequest)).data
        currentEoPVerificationReport.value = data[0]
        const reportConstituentItems = data[0]?.EoPSpecifications.map( x => {
            x.ItemType = ToCapitalSentenceCase(x.ItemType)
            return x
        })
        ReportConstituentItems.value = reportConstituentItems
        isLoadingReport.value = false
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Failed to download EoP verification reports."});
    }finally{
        isLoadingReport.value = false
    }
}

// TABLE
const isLoadingNewReport = ref(false);
const isLoadingReport = ref(false);
const currentEoPVerificationReport = ref<EoPVerificationReportOperation>();
const ReportConstituentItems = ref<EoPReportSpecifications[]>()
const ReportConstituentItemsCols: DisplayableKeys<EoPReportSpecifications>[] = ["ItemId", "ItemType", "Status", "ErrorTypes", "AmountExpected", "AmountReceived", "AmountDeviation", "JournalingStatus"];
const ReportConstituentItemsLabels: string[] = ["Item ID", "Item Type", "Status", "Error Types", "Amount Expected", "Amount Received", "Amount Deviation", "Journaling Status"];
const table = ref<ITableExpose<EoPVerificationReportOperation>>();

// Send POST request to create new EoP Verification Report
async function CreateNewReport() {
    if(isLoadingNewReport.value) return
    try {
        isLoadingNewReport.value = true;
        const eoPNewReportRequestBody:IEoPCreateNewReport = {
        market: market? market : "",
        startPeriodMonth: period.value? period.value : "",
        eoPType: journalType.value? journalType.value : "",
        userName: userName.value
        }
        await eoPCreateNewReport.post(eoPNewReportRequestBody)
        useNotifierWithErrFormatter().success({msg: "New EoP Verification Report has been created"})
        await GetEoPVerificationReport(journalType.value,market,period.value)
    } catch (error ){
        useNotifierWithErrFormatter().error({error, errorType: "Creating new EoP verification report"})
    } finally {
        isLoadingNewReport.value = false;
    }
}
async function CreateNewMultiplePeriodReport(startPeriod : DatePeriod, endPeriod : DatePeriod) {
    if(isLoadingNewReport.value) return
    try {
        isLoadingNewReport.value = true;
        const eoPNewReportRequestBody:IEoPCreateNewReport = {
        market: market? market.toString() : "",
        startPeriodMonth: startPeriod ? startPeriod.toString() : "",
        endPeriodMonth: endPeriod ? endPeriod.toString() : "",
        eoPType: journalType.value ? journalType.value : "",
        userName: userName.value
        }
        await eoPCreateNewReport.post(eoPNewReportRequestBody)
        useNotifierWithErrFormatter().success({msg: "New Multiple Period EoP Verification Report has been created"})
        await GetEoPVerificationReport(journalType.value,market,period.value)
    } catch (error ){
        useNotifierWithErrFormatter().error({error, errorType: "Creating new EoP verification report"})
    } finally {
        isLoadingNewReport.value = false;
    }
}
function ToCapitalSentenceCase(string: string){
    return string.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, (character: string) => character.toUpperCase())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (isLoadingReport.value || isLoadingNewReport.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_9,
                      _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.displayedEoPVerificationsList?.find((EoPItem) => EoPItem.EoPType === journalType.value.toString())?.EoPName), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _createElementVNode("td", _hoisted_12, _toDisplayString(period.value), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_13,
                      _createElementVNode("td", null, [
                        (
                                        currentEoPVerificationReport.value?.EoPStatus.toUpperCase().startsWith(
                                                'ERROR'
                                            )
                                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(currentEoPVerificationReport.value?.EoPStatus) + " - DEVIATIONS DETECTED ", 1))
                          : (currentEoPVerificationReport.value?.EoPStatus.toUpperCase() == 'SUCCESS')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(currentEoPVerificationReport.value?.EoPStatus), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(currentEoPVerificationReport.value?.EoPStatus), 1))
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _createElementVNode("td", null, [
                        (currentEoPVerificationReport.value?.JournalingStatus.toUpperCase() == 'INCOMPLETE')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(currentEoPVerificationReport.value?.JournalingStatus), 1))
                          : (currentEoPVerificationReport.value?.JournalingStatus == 'COMPLETE')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(currentEoPVerificationReport.value?.JournalingStatus), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(currentEoPVerificationReport.value?.JournalingStatus), 1))
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_21,
                      _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.PerformedOn.replace("T", " ")), 1)
                    ]),
                    _hoisted_22,
                    _createElementVNode("tr", null, [
                      _hoisted_23,
                      _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.AmountExpected), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_24,
                      _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.AmountReceived), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_25,
                      _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.AmountDeviation), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_26,
                      _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.NumberOfErrors), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (CreateNewReport())),
                    disabled: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport),
                    title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport) ? 'Create New Report (Access Denied)' : 'Create New Report',
                    class: "new-report-button"
                  }, " Create New Report ", 8, _hoisted_28),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showMultiplePeriodReportPopUp.value = !showMultiplePeriodReportPopUp.value)),
                    disabled: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport),
                    title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport) ? 'Create New Report (Access Denied)' : 'Create New Report',
                    class: "new-report-button"
                  }, " Create New Multiple Period Report ", 8, _hoisted_29),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (popUpOpen.value = true)),
                    title: "View Report History",
                    class: "new-report-button"
                  }, " View Report History ")
                ])
              ])
            ]),
            (!!ReportConstituentItems.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(ExportCsv, {
                      dataToDownload: filteredTableData.value,
                      fileName: ToCapitalSentenceCase(journalType.value) + '-' + period.value + '-' + 'EoP Report'
                    }, null, 8, ["dataToDownload", "fileName"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(Table, {
                      ref_key: "table",
                      ref: table,
                      Rows: ReportConstituentItems.value,
                      Cols: ReportConstituentItemsCols,
                      Labels: ReportConstituentItemsLabels
                    }, {
                      Status: _withCtx(({value}) => [
                        _createVNode(TickCrossBooleanDisplay, {
                          value: value.Status
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["Rows"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(EopVerificationReportHistoryPopUp, {
      modelValue: popUpOpen.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((popUpOpen).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(MultiplePeriodEoPVerificationReportPopUp, {
      modelValue: showMultiplePeriodReportPopUp.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showMultiplePeriodReportPopUp).value = $event)),
      period: period.value,
      onConfirm: CreateNewMultiplePeriodReport
    }, null, 8, ["modelValue", "period"])
  ], 64))
}
}

})